import * as React from 'react';
import {Select, type SelectMultiProps} from '../select';
import type {SelectValue} from '../_select-internals';
import type {ReactNode} from 'react';

type CreatableMultiSelectProps<
  T = unknown,
  V extends SelectValue = string,
  L extends ReactNode = string,
> = Omit<SelectMultiProps<T, V, L>, 'isCreatable' | 'isMulti'>;

const CreatableMultiSelect = React.forwardRef(function CreatableMultiSelect<
  T = unknown,
  V extends SelectValue = string,
  L extends ReactNode = string,
>(props: CreatableMultiSelectProps<T, V, L>, ref: React.Ref<HTMLDivElement>) {
  return (
    <Select
      ref={ref}
      {...(props as SelectMultiProps<T, V, L>)}
      searchable={props.searchable ?? true}
      isMulti
      isCreatable
    />
  );
}) as <T = unknown, V extends SelectValue = string, L extends ReactNode = string>(
  props: CreatableMultiSelectProps<T, V, L> & {ref?: React.Ref<HTMLDivElement>},
) => React.ReactElement;

export {CreatableMultiSelect};
export type {CreatableMultiSelectProps};
